var map = {
	"./caption-03-chs.webp": 88808,
	"./caption-03-cht.webp": 31872,
	"./caption-03-en.webp": 30695,
	"./caption-03-jp.webp": 3049,
	"./caption-03-kr.webp": 41095
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 96009;